import Vue from 'vue'
import global from '@/global.js'
import App from '@/App.vue'
import router from '@/router.js'
import store from '@/store.js'
import bugsnag from 'services/bugsnag.js'
import Vuelidate from 'vuelidate'
import errorHelper from '@/helpers/errorHelper'
import locale from '@/mixins/locale/locale.js'
import auth from 'services/auth.js'

let app

Vue.config.productionTip = false

Vue.use(Vuelidate)
locale(Vue)
global(Vue)
bugsnag.init(Vue)

Vue.prototype.$errorHelper = errorHelper

auth.init()
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  }
})
